/**
 * Aplicación web Directorio del Ayuntamiento de Zamora.
 * 
 * Desarrollo e implementación: Jaime León Pereira.
 * Ingeniero Informático de la Unidad TIC.
 */
import React from "react";
import ReactDOM from "react-dom";

/**
 * Componente de modal de confirmación reutilizable.
 * 
 * Muestra un cuadro de diálogo modal con un mensaje personalizado
 * y botones para confirmar o cancelar una acción.
 * Se renderiza como portal directo en el body del documento
 * para evitar problemas de z-index y posicionamiento.
 */
const ConfirmModal = ({ isOpen, onClose, onConfirm, message }) => {
  /* ============================
     Render condicional
     ============================ */
  
  // Si el modal no está abierto, no renderizar nada
  if (!isOpen) return null;

  /* ============================
     Render como portal
     ============================ */
  
  // Crear portal directo al body para evitar problemas de posicionamiento
  return ReactDOM.createPortal(
    /* Contenedor del modal con overlay oscuro */
    <div className="modal-backdrop">
      {/* Contenido principal del modal */}
      <div className="modal-content">
        {/* Mensaje de confirmación personalizado */}
        <p>{message}</p>
        {/* Contenedor de botones de acción */}
        <div className="modal-buttons">
          {/* Botón de confirmación */}
          <button className="btn btn-danger" onClick={onConfirm}>
            Confirmar
          </button>
          {/* Botón de cancelación */}
          <button className="btn btn-secondary" onClick={onClose}>
            Cancelar
          </button>
        </div>
      </div>

      {/* =============================
          Estilos CSS-in-JS
        ============================= */}
      <style jsx>{`
      /* Overlay oscuro semitransparente que cubre toda la pantalla */
        .modal-backdrop {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
      /* Contenedor del contenido del modal */
        .modal-content {
          background: white;
          padding: 20px;
          border-radius: 8px;
          max-width: 400px;
          width: 90%;
          text-align: center;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
        }
        .modal-buttons {
          margin-top: 20px;
          display: flex;
          justify-content: space-around;
        }
      `}</style>
    </div>,
    // Renderizar como portal directo al body del documento
    document.body
  );
};

export default ConfirmModal;
